import './index.css'

import React from "react";
import { Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Col, Divider, Form, Input, Row, Typography, Upload, message } from "antd";


import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../../services/hello-api";

import { IoCameraOutline, IoPersonCircle } from "react-icons/io5";

import logo from '../../assets/images/newlogo.png';

class Telao extends React.Component {

    state = { _loading: true, _navigate: false, dados: null, _menu: false, _params: window.location.href.split('/'), last: 0 }

    componentDidMount = () => {
        this.onView()
        if (!localStorage.getItem('telaoSeconds')) localStorage.setItem('telaoSeconds', 10)
        setInterval(() => {
            this.onView()
        }, 1000 * parseInt(localStorage.getItem('telaoSeconds')));
    }

    onView = () => {
        POST_API('/timeline/telao.php', { token: getToken(), filser: JSON.stringify({ EVENT_ID: this.state._params[4], LAST_ID: this.state.last }) }).then(rs => rs.json()).then(res => {
            this.setState({ dados: res.data, last: res.data.ID })
        }).catch(() => POST_CATCH()).finally(() => {
            this.setState({ _loading: false })
        })
    }

    render = () => {
        return (
            <div className="telao">
                <div className="telao-card">
                    {this.state.dados?.AVATAR ? <Avatar size={50} src={this.state.dados.AVATAR} /> : <IoPersonCircle className='no-avatar' />}
                    <Typography style={{ marginLeft: 10, fontSize: '1.6em' }}>{this.state.dados?.NAME}</Typography>
                </div>
                <center><img src={this.state.dados?.PHOTO} className="telao-foto" /></center>
                <img src={logo} className="telao-logo" />
            </div>
        )
    }

}

export default Telao;